import clsx from "clsx";
import {
  IGIcon,
  SnapChatIcon,
  TikTokIcon,
  TwitterIcon,
  BlackYoutubeIcon,
  BlackLinkedInIcon,
  LinkedinIcon,
  BlackTwitterIcon,
  SnapchatBlackIcon,
  BlackFacebookIcon,
} from "../../../../../assets/icons";

export const socialLog: any = {
  instagram: <IGIcon />,
  tiktok: <TikTokIcon />,
  snapchat: <SnapChatIcon />,
  "x (twitter)": <TwitterIcon />,
  youtube: <BlackYoutubeIcon width={18} height={18} />,
  linkedin: <LinkedinIcon width={18} height={18} />,
};

export const blackSocialLog: any = {
  youtube: <BlackYoutubeIcon width={18} height={18} />,
  linkedin: <BlackLinkedInIcon width={18} height={18} />,
  "x (twitter)": <BlackTwitterIcon width={18} height={18} />,
  snapchat: <SnapchatBlackIcon />,
  tiktok: <TikTokIcon />,
  facebook: <BlackFacebookIcon />,
}

const links: any = {
  instagram: "https://www.instagram.com",
  "x (twitter)": "https://www.x.com",
  tiktok: "https://www.tiktok.com",
  youtube: "https://www.youtube.com",
  linkedin: "https://www.linkedin.com/in",
  snapchat: "https://www.snapchat.com/add",
};

const SocialWidget = ({ data }: { data: any }) => {
  let linkToSocial = [];
  for (const key in data?.creator?.socialMedia) {
    linkToSocial.push({ type: key, username: data?.creator?.socialMedia[key] });
  }

  return (
    <section className="bg-white flex flex-col py-3 px-4 rounded-2xl w-full flex-1 border-[1px] border-gray-300">
      <div className="w-full flex items-center justify-between mb-3">
        <h6 className="font-gt-su-md text-sm text-black-100">Socials</h6>
      </div>

      <section className="grid grid-cols-2 grid-rows-2 gap-2">
        {linkToSocial?.map((datum: any) => {
          return (
            <Social
              type={datum?.type}
              key={datum?.type}
              username={datum?.username}
            />
          );
        })}
      </section>
    </section>
  );
};

export default SocialWidget;

const Social = ({
  type,
  username,
}: {
  type: string;
  username: string;
}) => {
  return (
    <section
      className={clsx(
        "w-20 bg-[#F6F6F6] md:w-[94px] lg:w-full flex flex-col gap-1 rounded-lg p-2"
      )}
    >
      <header className="flex items-center justify-between">
        <a
          href={`${links[type]}/${username}`}
          target="_blank"
          rel="noreferrer"
          className="text-[10px] font-gt-w-regular gap-1 rounded-full flex items-center justify-center "
        >
          {
            <span
              rel="noreferrer"
              className="w-6 h-6 rounded-md flex justify-center items-center bg-black-100 hover:opacity-80 transition-opacity"
            >
              {socialLog[type.toLowerCase()]}
            </span>
          }
          {username}
        </a>
      </header>
    </section>
  );
};
